import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="parameterize"
export default class extends Controller {
  static outlets = ["parameterize"];
  static values = { routingTarget: String };

  updateSlug() {
    if (this.hasParameterizeOutlet) {
      let parameterizedSlug = this.element.value
        .trim()
        .toLowerCase()
        .replaceAll(/[^a-zA-Z0-9\s\-_]/g, "")
        .replaceAll(/\s/g, "_");
      this.parameterizeOutletElement.value = parameterizedSlug;

      // Also update routing field if configured
      if (this.hasRoutingTargetValue) {
        const routingField = document.querySelector(this.routingTargetValue);
        if (routingField) {
          routingField.value = `${parameterizedSlug}/:handle`;
        }
      }
    }
  }
}
